import React, { useContext, useEffect, useState } from "react";
import SessionConfig from "./SessionConfig";
import CoachConfig from "./CoachConfig";
import ResponseConfig from "./ResponseConfig";
import AdminConfig from "./AdminConfig";
import WorkspaceConfig from "./WorkspaceConfig";
import AgentConfig from "../Course/Agent/AgentsAdmin";
import CourseConfig from "../Course/CourseAdmin";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../../UserContext";

const Config = () => {
  const [activeTab, setActiveTab] = useState("Session");
  const navigate = useNavigate();
  const { user } = useContext(UserContext);

  useEffect(() => {
    if (
      user.user_role === "ac9be322-db89-4beb-854a-46f2c91de374" ||
      user.user_role === "5aee1e31-cc95-49d9-9ed7-10c4e4b6fdef"
    ) {
      console.log("you are admin", user.user_id);
    } else {
      navigate("/");
      console.log("you are not admin");
    }
  }, [navigate, user.user_id, user.user_role]);

  const renderContent = () => {
    switch (activeTab) {
      case "Session":
        return <SessionConfig />;
      case "Session Configuration":
        return <CoachConfig />;
      case "Prompts":
        return <ResponseConfig />;
      case "Workspace":
        return <WorkspaceConfig />;
      case "Admin Access":
        return <AdminConfig />;
      case "Agents":
        return <AgentConfig />;
      case "Courses":
        return <CourseConfig />;
      default:
        return null;
    }
  };

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar */}
      <div className="w-64 bg-white border-r border-gray-200 p-6 fixed top-0 left-0 h-full mt-32">
        <h2 className="font-semibold text-gray-700 text-xl mb-8">
          Configuration
        </h2>
        <div className="space-y-2">
          {[
            "Session Configuration",
            "Prompts",
            "Workspace",
            "Admin Access",
            "Agents",
            "Courses",
          ].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`w-full flex items-center text-left py-3 px-4 rounded-lg transition-all ${
                activeTab === tab
                  ? "bg-teal-50 text-teal-600 font-medium"
                  : "text-gray-500 hover:bg-gray-100"
              }`}
            >
              <span className="mr-3">📁</span>
              {tab}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-4 ml-48 flex-1">
        <div className="w-full">
          <div className="p-2">{renderContent()}</div>
        </div>
      </div>
    </div>
  );
};

export default Config;
